import React from 'react';
import PropTypes from 'prop-types';
import ButtonEdit from '../ButtonEdit';
import Edit from './Edit';
import View from './View';

const AdditionalCoverages = ({
  edit,
  confirm,
  enabled,
  confirmed,
  liquorPrice,
  damageToRentedPropertyPrice,
  sellingLiquor,
  damageToRentedProperty,
  hostLiquorHide,
  liquorLiabilityHide,
  personalPropertyHide,
  terrorismHide,
  damageToRentedPropertyHide,
  hostLiquorMandatory,
  liquorLiabilityMandatory,
  personalPropertyMandatory,
  terrorismMandatory,
  damageToRentedPropertyMandatory,
  additionalCoverageRef,
}) => (
  <div
    className={`component ${enabled ? 'enabled' : 'disabled'}`}
    ref={additionalCoverageRef}
  >
    <div className="form-row justify-content-between">
      <div className="col-auto my-auto">
        <h3>Additional Coverages</h3>
      </div>
      <ButtonEdit edit={edit} show={confirmed} />
    </div>
    <div className="card">
      <div className="card-body">
        <Edit
          show={!confirmed}
          confirm={confirm}
          enabled={enabled}
          liquorPrice={liquorPrice}
          damageToRentedPropertyPrice={damageToRentedPropertyPrice}
          hostLiquorHide={hostLiquorHide}
          liquorLiabilityHide={liquorLiabilityHide}
          personalPropertyHide={personalPropertyHide}
          terrorismHide={terrorismHide}
          damageToRentedPropertyHide={damageToRentedPropertyHide}
          hostLiquorMandatory={hostLiquorMandatory}
          liquorLiabilityMandatory={liquorLiabilityMandatory}
          personalPropertyMandatory={personalPropertyMandatory}
          terrorismMandatory={terrorismMandatory}
          damageToRentedPropertyMandatory={damageToRentedPropertyMandatory}
        />
        <View
          show={confirmed}
          liquorPrice={liquorPrice}
          damageToRentedPropertyPrice={damageToRentedPropertyPrice}
          sellingLiquor={sellingLiquor}
          damageToRentedProperty={damageToRentedProperty}
          hostLiquorHide={hostLiquorHide}
          liquorLiabilityHide={liquorLiabilityHide}
          personalPropertyHide={personalPropertyHide}
          damageToRentedPropertyHide={damageToRentedPropertyHide}
          terrorismHide={terrorismHide}
        />
      </div>
    </div>
  </div>
);
AdditionalCoverages.propTypes = {
  edit: PropTypes.func.isRequired,
  confirm: PropTypes.func.isRequired,
  enabled: PropTypes.bool.isRequired,
  confirmed: PropTypes.bool.isRequired,
  liquorPrice: PropTypes.number.isRequired,
  damageToRentedPropertyPrice: PropTypes.number.isRequired,
  sellingLiquor: PropTypes.bool.isRequired,
  damageToRentedProperty: PropTypes.bool.isRequired,
  hostLiquorHide: PropTypes.bool.isRequired,
  liquorLiabilityHide: PropTypes.bool.isRequired,
  personalPropertyHide: PropTypes.bool.isRequired,
  terrorismHide: PropTypes.bool.isRequired,
  damageToRentedPropertyHide: PropTypes.bool.isRequired,
  hostLiquorMandatory: PropTypes.bool.isRequired,
  liquorLiabilityMandatory: PropTypes.bool.isRequired,
  personalPropertyMandatory: PropTypes.bool.isRequired,
  terrorismMandatory: PropTypes.bool.isRequired,
  damageToRentedPropertyMandatory: PropTypes.bool.isRequired,
  additionalCoverageRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]).isRequired,
};

export default AdditionalCoverages;
